import { HttpErrorResponse } from '@angular/common/http';

export function getHttpErrorMessage(error: unknown): string {
  if (!(error instanceof HttpErrorResponse)) {
    return 'Er is iets misgegaan. Probeer het opnieuw.';
  }

  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    return 'Geen internet beschikbaar.';
  }

  switch (error.status) {
    case 400:
      return getBadRequestMessage(error);
    case 401:
      return 'Je inloggegevens zijn incorrect.';
    case 403:
      return 'Je hebt niet de juiste rechten voor deze actie.';
    case 404:
      return 'Niet gevonden.';
    case 408:
      return 'Het verzoek duurde te lang. Probeer het opnieuw.';
    case 409:
      return 'Deze gegevens zijn inmiddels gewijzigd. Ververs de pagina en probeer het opnieuw.';
    case 422:
      return 'De ingevoerde gegevens zijn ongeldig.';
    case 429:
      return 'Te veel pogingen. Probeer het later opnieuw.';
    case 500:
      return 'Er is een fout opgetreden op de server. Probeer het later opnieuw.';
    case 502:
      return 'De server is tijdelijk niet bereikbaar. Probeer het later opnieuw.';
    case 503:
      return 'De dienst is momenteel niet beschikbaar. Probeer het later opnieuw.';
    case 504:
      return 'Het verzoek duurde te lang om af te handelen. Probeer het opnieuw.';
  }

  if (error.status >= 500) {
    return 'Server is op dit moment niet beschikbaar.';
  }

  if (error.status >= 400) {
    return 'Incorrecte gegevens ingevoerd.';
  }

  return 'Er is iets misgegaan. Probeer het opnieuw.';
}

/** Custom validation errors from the API come back as a 400 with `{ error: 'Bad Request', message }`. */
function getBadRequestMessage(error: HttpErrorResponse): string {
  const body = error.error;
  if (body?.error === 'Bad Request' && body?.message) {
    return body.message;
  }
  return 'Verkeerd ingevuld formulier.';
}
